export default __webpack_public_path__ + "static/media/13.ea05db02.jpg";